<template>
  <footer class="colophon">
    <div class="container colophon-inner">
      <p class="colophon-line label">
        <span>BJÖRN KOEMANS</span>
        <span>UNCAPPED WORKS</span>
        <span>VUE 3</span>
        <span>UTRECHT, NL</span>
        <span>© {{ year }}</span>
      </p>

      <div class="colophon-links">
        <a class="colophon-link" :href="cvHref" target="_blank" rel="noopener">
          {{ $t("nav.downloadCv") }}
        </a>
        <a
          class="colophon-link"
          href="https://github.com/bjornkoemans"
          target="_blank"
          rel="noopener"
          >GitHub</a
        >
        <a
          class="colophon-link"
          href="https://www.linkedin.com/in/bjornkoemans"
          target="_blank"
          rel="noopener"
          >LinkedIn</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default {
  name: "AppFooter",
  setup() {
    const { locale } = useI18n();
    // Stamped at build time rather than hardcoded, so the colophon cannot
    // quietly go stale in January.
    const year = new Date().getFullYear();
    const cvHref = computed(() =>
      locale.value === "nl"
        ? "/cv/Bjorn-Koemans-CV-NL.pdf"
        : "/cv/Bjorn-Koemans-CV-EN.pdf"
    );
    return { year, cvHref };
  },
};
</script>

<style scoped>
.colophon {
  border-top: var(--hair-w) solid var(--hairline);
  padding: var(--s-6) 0 calc(var(--s-6) + env(safe-area-inset-bottom));
  margin-top: var(--s-8);
}

.colophon-inner {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--s-5);
  flex-wrap: wrap;
}

.colophon-line {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  letter-spacing: 0.08em;
  margin: 0;
}
.colophon-line span:not(:last-child)::after {
  content: "·";
  margin: 0 0.7em;
  opacity: 0.5;
}

.colophon-links {
  display: flex;
  gap: var(--s-5);
}
.colophon-link {
  font-family: var(--font-measure);
  font-size: var(--m-label);
  font-weight: 500;
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  color: var(--grey);
  transition: color var(--d-1) ease;
}
.colophon-link:hover {
  color: var(--accent);
}

@media (max-width: 720px) {
  .colophon {
    /* clear the fixed MobileBar */
    padding-bottom: calc(var(--s-10) + env(safe-area-inset-bottom));
  }
  .colophon-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--s-4);
  }
}
</style>
